var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7871 13.8055C23.3323 11.932 20.6678 11.932 20.213 13.8055C19.9191 15.0158 18.5326 15.5901 17.469 14.9421C15.8226 13.9389 13.9386 15.823 14.9417 17.4694C15.5898 18.5329 15.0154 19.9195 13.8052 20.2133C11.9316 20.6682 11.9316 23.3326 13.8052 23.7875C15.0154 24.0813 15.5898 25.4679 14.9417 26.5314C13.9386 28.1778 15.8226 30.0618 17.469 29.0587C18.5326 28.4107 19.9191 28.985 20.213 30.1953C20.6678 32.0688 23.3323 32.0688 23.7871 30.1953C24.0809 28.985 25.4675 28.4107 26.531 29.0587C28.1774 30.0618 30.0615 28.1778 29.0583 26.5314C28.4103 25.4679 28.9846 24.0813 30.1949 23.7875C32.0684 23.3326 32.0684 20.6682 30.1949 20.2133C28.9846 19.9195 28.4103 18.5329 29.0583 17.4694C30.0615 15.823 28.1774 13.9389 26.531 14.9421C25.4675 15.5901 24.0809 15.0158 23.7871 13.8055ZM22 25.6004C23.9882 25.6004 25.6 23.9886 25.6 22.0004C25.6 20.0122 23.9882 18.4004 22 18.4004C20.0118 18.4004 18.4 20.0122 18.4 22.0004C18.4 23.9886 20.0118 25.6004 22 25.6004Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.53e5ba2fb2bc415db06fd02a847dcb72.svg";
export { ForwardRef as ReactComponent };